import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { SHELL_TEXT } from "../content.js";
import { IconExternal, IconLoader } from "../icons.js";
import { PlainLink, cx } from "../link.js";
function ButtonContent({ loading, icon: Icon, children }) {
    return (_jsxs(_Fragment, { children: [loading ? _jsx(IconLoader, { className: "we-spin" }) : Icon ? _jsx(Icon, {}) : null, _jsx("span", { children: children })] }));
}
export function Button({ variant = "secondary", block, loading, icon, className, disabled, children, type = "button", ...rest }) {
    return (_jsx("button", { type: type, className: cx("we-btn", `we-btn--${variant}`, block && "we-btn--block", className), disabled: disabled || loading, "aria-busy": loading || undefined, ...rest, children: _jsx(ButtonContent, { loading: loading, icon: icon, children: children }) }));
}
/** Link com cara de botão, para a ação principal que muda de página (ex.: "Criar dinâmica"). */
export function ButtonLink({ variant = "secondary", block, icon, linkAs: Link = PlainLink, className, children, ...rest }) {
    return (_jsx(Link, { className: cx("we-btn", `we-btn--${variant}`, block && "we-btn--block", className), ...rest, children: _jsx(ButtonContent, { icon: icon, children: children }) }));
}
export function TextLink({ linkAs: Link = PlainLink, className, ...rest }) {
    return _jsx(Link, { className: cx("we-link", className), ...rest });
}
/**
 * Único tipo de link que sai da plataforma (Biografia Preta, DESIGN_SYSTEM §5): sempre com "Abre outro
 * site" e o ícone, na mesma aba (D30).
 */
export function ExternalLink({ className, children, note = SHELL_TEXT.abreOutroSite, ...rest }) {
    return (_jsxs("a", { className: cx("we-link", "we-link--external", className), ...rest, children: [_jsx("span", { children: children }), _jsxs("span", { className: "we-external-note", children: [note, _jsx(IconExternal, {})] })] }));
}
